import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";

/** Utilities */
import { encryptUrlData } from "../../services/CryptoService";
import { getProjectGradient } from "../../lib/getProjectGradient";

/** Common Components */
import Avatar from "../../components/ui/avatar/Avtar";
import Iconify from "../../layouts/components/iconify/iconify";
import CardSection from "../../components/ui/card/CardSection";
import NoDataFound from "../../components/ui/noDataFound/NoDataFound";

/** RTK Query */
import { useLazyGetUserAssignProjectsListQuery } from "../../app/services/projectManagementAPI";

/** CSS Files */
import "./MyProjects.scss";

const MyProjects = () => {
  const [myProjectList, setMyProjectList] = useState([]);

  const [
    getUserAssignProjectsList,
    {
      isLoading: isListLoading,
      isFetching: isListFetching,
      isSuccess: isListSuccess,
      data: myProjectListData,
    },
  ] = useLazyGetUserAssignProjectsListQuery();

  const navigate = useNavigate();

  const { user } = useSelector((state) => state.auth);

  const handleBackButtonClick = (project) => {
    if (project.projectId) {
      navigate(`/myprojects/tasklist/${encryptUrlData(project)}`);
    }
  };

  useEffect(() => {
    if (user) {
      let userId = user.userId;
      getUserAssignProjectsList(userId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  useEffect(() => {
    if (!isListFetching && isListSuccess && myProjectListData) {
      setMyProjectList(myProjectListData);
    }
  }, [isListFetching, isListSuccess, myProjectListData]);

  return (
    <div className="my-project-card center-top-space">
      <CardSection isContentLoading={isListLoading} cardTitle={"My Projects"}>
        {myProjectList.length > 0 ? (
          <div className="card-view">
            <div className="grid-container">
              {myProjectList.map((project, index) => (
                <div className="" key={project.projectId}>
                  <button
                    className="project-card"
                    onClick={() => handleBackButtonClick(project)}
                  >
                    <div className="card-part">
                      <div className="avatar-container">
                        <Avatar
                          src=""
                          alt={project.projectName}
                          fallbackText={project.projectCode || undefined}
                          size="large"
                          shape="circle"
                          gradient={getProjectGradient(project.projectId)}
                        />
                        <div className="avatar-title">
                          <h2 className="card-title">{project.projectName}</h2>
                          <div className="project-code">
                            Code : {project.projectCode}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card-content">
                      <div className="card-info">
                        <div className="card-info-details">
                          <Iconify icon="ph:user-duotone" />
                          <span>Responsible User :</span>
                          <p>{project.responsibleUser}</p>
                        </div>
                        <div className="card-info-details">
                          <Iconify icon="ri:customer-service-2-fill" />
                          <span>Customer :</span>
                          <p>{project.companyName}</p>
                        </div>
                        <div className="card-info-details">
                          <Iconify icon="fluent:clipboard-task-list-20-regular" />
                          <span>No. of Tasks :</span>
                          <p>{project.taskCount}</p>
                        </div>
                        <div className="card-info-details">
                          <Iconify icon="mynaui:users-group" />
                          <span>No. of Members :</span>
                          <p>{project.memberCount}</p>
                        </div>
                        <div className="card-info-details">
                          <Iconify icon="mynaui:users-group" />
                          <span>No. of My Tasks :</span>
                          <p>{project.mytaskCount}</p>
                        </div>
                      </div>
                    </div>
                  </button>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <NoDataFound />
        )}
      </CardSection>
    </div>
  );
};

export default MyProjects;
